export default __webpack_public_path__ + "static/media/devices.9aaeed6a.svg";